import { useRef, useState, useEffect, useCallback } from "react";

export function useElementBounds(enabled, portalElement = null) {
  const ref = useRef(null);
  const [bounds, setBounds] = useState(null);

  const updateBounds = useCallback(() => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();

    let top = rect.top + window.scrollY;
    let left = rect.left + window.scrollX;

    // If portal element is provided and is not body/document,
    // calculate coordinates relative to the portal element
    if (
      portalElement &&
      portalElement !== document.body &&
      portalElement !== document.documentElement
    ) {
      const portalRect = portalElement.getBoundingClientRect();
      top = rect.top - portalRect.top + portalElement.scrollTop;
      left = rect.left - portalRect.left + portalElement.scrollLeft;
    }

    setBounds({
      top,
      left,
      width: rect.width,
      height: rect.height,
    });
  }, [portalElement]);

  useEffect(() => {
    if (!enabled || !ref.current) return;

    updateBounds();
    window.addEventListener("scroll", updateBounds);
    window.addEventListener("resize", updateBounds);

    return () => {
      window.removeEventListener("scroll", updateBounds);
      window.removeEventListener("resize", updateBounds);
    };
  }, [enabled]);

  return [ref, bounds, updateBounds];
}
